import { useEffect } from "react";

/** On every new view: close the drawer and start the content at the top. */
export function useViewChange(viewKey: string | undefined, mainId: string, closeDrawer: () => void): void {
  useEffect(() => {
    closeDrawer();
    document.getElementById(mainId)?.scrollTo({ top: 0 });
  }, [viewKey]); // eslint-disable-line react-hooks/exhaustive-deps
}
